import { MarkdownUtil } from "util/markdown/MarkdownUtil";
import { ObjectUtils } from "util/ObjectUtils";
import { ComentarioCamposFormulario } from "../../view/section/SolicitacaoComentariosSecao/NovoComentarioTag/NovoComentarioCamposFormulario";
import { validadorAnexos } from "./AnexosValidacao";

export const validadorNovoComentarioFormulario = (formulario: ComentarioCamposFormulario) => {
  const erros: {[key: string]: {[key: string]: string}} = { };

  const mensagem = formulario.comentario.mensagem?.trim() ?? "";
  const comentarioMarkdown = MarkdownUtil.toMarkdown(mensagem);

  if (comentarioMarkdown === undefined || comentarioMarkdown === "" || comentarioMarkdown === "<br>") {
    ObjectUtils.popular(erros, 'Comentário é um campo obrigatório', "comentario.mensagem");
  } else if (comentarioMarkdown.length < 15) {
    ObjectUtils.popular(erros, 'Este comentário é muito curto', "comentario.mensagem");
  }

  return {
    ...erros,
    ...validadorAnexos("comentario.anexos", formulario.comentario.anexos)
  }
}